/* ============================================================
   AM BABY & KIDS — Google Analytics 4
   Módulo único de eventos. Ningún gtag() suelto en otros archivos:
   todo pasa por window.PSAnalytics.

   Nombres tomados del diccionario de eventos de PS Digitales, y de los
   nombres recomendados de GA4 donde existen (view_item, add_to_cart,
   begin_checkout…), que son los que alimentan los informes de monetización.
   ============================================================ */

'use strict';

(function () {
  var CTX = window.GA4_CONTEXT || {};
  var CURRENCY = CTX.currency || 'MXN';

  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, params || {});
  }

  /* --- Ubicación del CTA ---
     Valores del diccionario: header · hero · body · footer · floating · popup.
     data-cta-location en el enlace o en cualquier ancestro tiene prioridad. */
  function ctaLocation(el) {
    var explicit = el.closest('[data-cta-location]');
    if (explicit) return explicit.getAttribute('data-cta-location');
    if (el.closest('.whatsapp-float')) return 'floating';
    if (el.closest('.site-header')) return 'header';
    if (el.closest('.site-footer, footer')) return 'footer';
    if (el.closest('.hero-section')) return 'hero';
    return 'body';
  }

  function ctaText(el) {
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t) t = el.getAttribute('aria-label') || '';
    return t.slice(0, 100);
  }

  function pagePath() {
    return location.pathname + location.search;
  }

  /* --- Clics de contacto y de producto, por delegación ---
     Un solo listener: los botones que se agreguen en el futuro se miden
     solos, sin tocar este archivo. En fase de captura para que ningún
     stopPropagation de theme.js se lo coma. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';

    if (href.indexOf('wa.me') !== -1 || href.indexOf('api.whatsapp.com') !== -1) {
      PSAnalytics.whatsappClick(ctaLocation(link), ctaText(link));
      return;
    }
    if (href.indexOf('tel:') === 0) {
      PSAnalytics.contactClick('phone_click', ctaLocation(link), ctaText(link));
      return;
    }
    if (href.indexOf('mailto:') === 0) {
      PSAnalytics.contactClick('email_click', ctaLocation(link), ctaText(link));
      return;
    }

    // Clic en una tarjeta de producto dentro de un listado
    var card = link.closest('.product-card[data-ga-item-id]');
    if (card && href.indexOf('/products/') !== -1) {
      send('select_item', {
        item_list_name: CTX.list_name || 'listado',
        items: [{
          item_id: card.getAttribute('data-ga-item-id'),
          item_name: card.getAttribute('data-ga-item-name'),
          item_category: card.getAttribute('data-ga-item-category'),
          price: parseFloat(card.getAttribute('data-ga-price')) || 0,
          quantity: 1
        }]
      });
    }
  }, true);

  /* --- Profundidad de scroll: 25 / 50 / 75 / 90 % --- */
  function initScrollDepth() {
    var marks = [25, 50, 75, 90];
    var hit = {};

    function check() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = ((window.scrollY || doc.scrollTop) / scrollable) * 100;

      marks.forEach(function (m) {
        if (pct >= m && !hit[m]) {
          hit[m] = true;
          send('scroll_depth', { percent_scrolled: m, page_path: pagePath() });
        }
      });

      if (hit[90]) window.removeEventListener('scroll', onScroll);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { check(); ticking = false; });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Eventos de ecommerce que dependen del template --- */
  function initPageEvents() {
    if (CTX.template === 'product' && CTX.item) {
      send('view_item', {
        currency: CURRENCY,
        value: CTX.item.price,
        items: [CTX.item]
      });
    }

    if (CTX.template === 'collection' && CTX.list_items && CTX.list_items.length) {
      send('view_item_list', {
        item_list_name: CTX.list_name,
        items: CTX.list_items
      });
    }

    if (CTX.template === 'search' && CTX.search_term) {
      send('search', {
        search_term: CTX.search_term,
        search_results: CTX.search_results
      });
    }

    if (CTX.template === 'cart' && CTX.cart_items && CTX.cart_items.length) {
      send('view_cart', {
        currency: CURRENCY,
        value: CTX.cart_value,
        items: CTX.cart_items
      });
    }
  }

  /* --- API pública ---
     theme.js la usa para lo que la delegación no puede ver: botones que no
     son enlaces, respuestas del carrito y validaciones fallidas. */
  window.PSAnalytics = {
    track: send,

    whatsappClick: function (location, text) {
      send('whatsapp_click', {
        cta_location: location || 'body',
        cta_text: text || '',
        page_path: pagePath()
      });
      // Un CTA de WhatsApp dispara los dos: el de conversión y el genérico
      // que permite comparar el rendimiento del copy entre botones.
      send('cta_click', {
        cta_location: location || 'body',
        cta_text: text || '',
        cta_type: 'whatsapp'
      });
    },

    contactClick: function (eventName, location, text) {
      send(eventName, {
        cta_location: location || 'body',
        cta_text: text || '',
        page_path: pagePath()
      });
    },

    /* Normaliza una línea de /cart/add.js o /cart.js al formato de GA4. */
    itemFromCartLine: function (line) {
      return {
        item_id: String(line.product_id || line.id || ''),
        item_name: line.product_title || line.title || '',
        item_category: line.product_type || 'Recuerditos',
        item_variant: line.variant_title || '',
        price: (line.price || line.final_price || 0) / 100,
        quantity: line.quantity || 1
      };
    },

    addToCart: function (lines) {
      var items = lines.map(this.itemFromCartLine);
      if (!items.length) return;
      var value = items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
      send('add_to_cart', { currency: CURRENCY, value: value, items: items });
    },

    removeFromCart: function (item) {
      send('remove_from_cart', {
        currency: CURRENCY,
        value: item.price * item.quantity,
        items: [item]
      });
    },

    beginCheckout: function (items, value) {
      send('begin_checkout', {
        currency: CURRENCY,
        value: value,
        items: items || []
      });
    },

    /* El embudo de este sitio se cae en las validaciones del carrito, no en
       el pago: form_error dice en cuál. No es evento clave. */
    formError: function (formName, errorField) {
      send('form_error', {
        form_name: formName,
        error_field: errorField,
        page_path: pagePath()
      });
    }
  };

  function start() {
    initPageEvents();
    initScrollDepth();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
